import { render, staticRenderFns } from "./LandlordDetails.vue?vue&type=template&id=7d5017e7&scoped=true"
import script from "./LandlordDetails.vue?vue&type=script&lang=js"
export * from "./LandlordDetails.vue?vue&type=script&lang=js"
import style0 from "./LandlordDetails.vue?vue&type=style&index=0&id=7d5017e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5017e7",
  null
  
)

export default component.exports